import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "logo logo-dark" }, null, -1)
const _hoisted_2 = {
  class: "box",
  "data-cy": "pending-verification"
}
const _hoisted_3 = { class: "box-content" }
const _hoisted_4 = { class: "headline" }
const _hoisted_5 = { class: "justify-content-center" }
const _hoisted_6 = {
  key: 0,
  class: "verify-text"
}
const _hoisted_7 = { class: "highlight-text" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "success-message" }
const _hoisted_11 = {
  class: "verification-buttons",
  style: {"justify-content":"space-between"}
}
const _hoisted_12 = { key: 0 }

import { getCurrentInstance, ref } from "vue";
    import { createCandidateService } from '@/services/candidateService';
    import { createAuthenticationService } from '@/services/authenticationService';
    import { useToast } from 'primevue/usetoast';
    import { useI18n } from "vue-i18n";
    import { CandidateProfile } from "@/models/CandidateProfile";
    import ChangeEmail from './ChangeEmail.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'VerifyEmail',
  emits: ['email-verified', 'error'],
  setup(__props, { expose: __expose, emit: __emit }) {


    const emit = __emit;
    const toaster = useToast();
    const app = getCurrentInstance();
    const emailSent = ref(false);
    const display = ref(false);
    const candidate = ref<CandidateProfile|null>();
    const { t } = useI18n();
    const changeEmailDialog = ref();

    const resendVerificationEmail = async function () {
        const result = await service.refreshToken();
        if (!result) {
            emailSent.value = false;
            return;
        }
        const candidateService = await createCandidateService(app);
        emailSent.value = await candidateService.triggerVerificationMail();
        if (emailSent.value) {
            toaster.add({
                severity: "success",
                summary: t("verifyemail.resend.mail.toast.success.title"),
                detail: t("verifyemail.resend.mail.toast.success.text"),
                life: 5000,
            });
        }
    }

    const service = createAuthenticationService(app);

    const show = async () => {
        const candidateService = await createCandidateService(app);
        if (!display.value) {
            candidate.value = await candidateService.get();
            display.value = true;
            await checkVerification();
        }
    };

    const close = async () => {
        const user = service.getUser();
        if (user && user.email_verified) {
            emit('email-verified');
            display.value = false;
        }
    }

    const changeEmail = () => {
        changeEmailDialog.value.show();
    }

    const emailChanged = async () => {
        await service.refreshToken();
        await service.updateAuthState();
    }

    const checkVerification = async () => {
        const result = await service.refreshToken();
        if (result == "already_requested")
            return;

        if (!result) {
            emit('error');
            return;
        }
        const user = service.getUser();

        if (user && user.email_verified) {
            await close();
        } else {
            if (display.value)
                setTimeout(checkVerification, 5000);
        }
    };

    __expose({
        show
    });

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      visible: display.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((display).value = $event)),
      modal: true,
      class: "verification-dialog",
      baseZIndex: 106
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.$t('verifyemail.headline-2')), 1),
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(app)?.appContext?.config?.globalProperties?.$auth?.user?.value?.email), 1)
            ]),
            (!_ctx.emailVerified)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('verifyemail.copy-1')) + " ", 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(app)?.appContext?.config?.globalProperties?.$auth?.user?.value?.email), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('verifyemail.copy-2')) + " ", 1),
                    _hoisted_8,
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('verifyemail.copy-3')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_Button, {
                        label: _unref(t)('verifyemail.change.verification.mail'),
                        onClick: changeEmail,
                        class: "button-secondary"
                      }, null, 8, ["label"]),
                      (!emailSent.value)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            label: _unref(t)('verifyemail.resend.verification.mail'),
                            onClick: resendVerificationEmail,
                            class: "button-primary"
                          }, null, 8, ["label"]))
                        : _createCommentVNode("", true)
                    ]),
                    (emailSent.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t('verifyemail.mail-triggered')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(ChangeEmail, {
      ref_key: "changeEmailDialog",
      ref: changeEmailDialog,
      onEmailChanged: emailChanged
    }, null, 512)
  ], 64))
}
}

})